import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

interface FetchIngredientsParams {
  page?: number;
  query?: string;
  perPage?: number;
}

export const fetchIngredients = createAsyncThunk(
  'ingredients/fetchIngredients',
  async ({ page = 1, query = '', perPage = 25 }: FetchIngredientsParams = {}) => {
    const params = new URLSearchParams()
    params.set('page', String(page))
    params.set('per_page', String(perPage))
    if (query) params.set('q', query)
    const response = await fetch(`/api/ingredients?${params}`)
    if (!response.ok) throw new Error('Failed to fetch ingredients')
    return response.json()
  }
)

interface FoodItem {
  id: number;
  name: string;
}

interface Pagination {
  page: number;
  perPage: number;
  totalCount: number;
  totalPages: number;
}

interface IngredientsState {
  items: FoodItem[];
  pagination: Pagination;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: IngredientsState = {
  items: [],
  pagination: { page: 1, perPage: 25, totalCount: 0, totalPages: 1 },
  status: 'idle',
  error: null,
}

const ingredientsSlice = createSlice({
  name: 'ingredients',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIngredients.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchIngredients.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.items = action.payload.ingredients
        const p = action.payload.pagination
        state.pagination = {
          page:       p.page,
          perPage:    p.per_page,
          totalCount: p.total_count,
          totalPages: p.total_pages,
        }
      })
      .addCase(fetchIngredients.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || null
      })
  },
})

export default ingredientsSlice.reducer
